const DIAS_BLOQUE = ['lu', 'ma', 'mi', 'ju', 'vi']
const DIA_SEMANA_BLOQUE = { lu: 'lunes', ma: 'martes', mi: 'miercoles', ju: 'jueves', vi: 'viernes' }
const NOMBRES_DIA = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']

export default {
  data: () => ({
    dialogHuellas: false,
    tipoHuellas: 1,
    searchHuellas: '',
    faltasHuellaSab: [],
    faltasHuellaQuin: [],
    excepcionesHuella: [],
    errorExcepcionesHuella: '',
    revisadoHuellaSab: false,
    revisadoHuellaQuin: false,
    baseComparativaHuellaQ: [],

    dialogExcepcionHuella: false,
    faltaHuellaSeleccionada: null,
    motivoExcepcionHuella: '',

    headersHuellas: [
      { text: 'id'            , value: 'id_teacher' },
      { text: 'Teacher'       , value: 'teacher' },
      { text: 'Fecha'         , value: 'fecha' },
      { text: 'Plantel'       , value: 'plantel' },
      { text: 'Grupos'        , value: 'grupos_texto' },
      { text: 'Horas'         , value: 'horas', align: 'end' },
      { text: 'Descuento'     , value: 'monto', align: 'end' },
      { text: 'Estatus'       , value: 'excepcion', sortable: false },
      { text: ''              , value: 'acciones', sortable: false, align: 'end' },
    ],
  }),

  computed: {
    quincenaHuellaActiva () {
      return [1, 3].includes(Number(this.selectedHeaders))
    },

    faltasHuellaVista () {
      return this.tipoHuellas == 2 ? this.faltasHuellaQuin : this.faltasHuellaSab
    },

    totalDescuentoHuellaVista () {
      return this.faltasHuellaVista
        .filter((f) => !f.excepcion)
        .reduce((suma, f) => suma + f.monto, 0)
    },

    huellaSabPendiente () {
      return this.faltasHuellaSab.length > 0 && !this.revisadoHuellaSab
    },

    huellaQuinPendiente () {
      return this.quincenaHuellaActiva && this.faltasHuellaQuin.length > 0 && !this.revisadoHuellaQuin
    },

    huellasPendientesRevision () {
      return this.huellaSabPendiente || this.huellaQuinPendiente
    },
  },

  methods: {
    normalizarFechaHuella (fecha) {
      if (!fecha) return ''
      return String(fecha).slice(0, 10)
    },

    hoyHuella () {
      const d = new Date()
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
    },

    formatoFechaHuella (fecha) {
      if (!fecha) return ''
      const partes = fecha.split('-')
      const d = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]))
      return NOMBRES_DIA[d.getDay()] + ' ' + partes[2] + '/' + partes[1] + '/' + partes[0]
    },

    esTeacherHuella (id) {
      const n = Number(id)
      return Number.isFinite(n) && n > 0 && n !== 1202
    },

    esGrupoOnlineHuella (grupo) {
      return String((grupo && grupo.grupo) || '').toUpperCase().indexOf('ONLINE') !== -1
    },

    tarifaHuella (idTeacher, campo) {
      const categoria = (this.pagos || []).find((el) => el.id_usuario == idTeacher)
      return categoria ? (Number(categoria[campo]) || 0) : 0
    },

    /** Teacher + fecha con al menos una checada (la API ya resuelve cualquier checada del día). */
    diasConChecadaHuella () {
      const dias = {}
      const grupos = (this.gruposActivos || []).concat(this.gruposQuincena || [])
      grupos.forEach((g) => {
        for (let semana = 1; semana <= 5; semana++) {
          DIAS_BLOQUE.forEach((d) => {
            const slot = d + semana
            const fecha = this.normalizarFechaHuella(g[slot + '_fecha'])
            if (fecha && g[slot] && g[slot + '_hora_asistencia']) {
              dias[g[slot] + '|' + fecha] = true
            }
          })
        }
      })
      return dias
    },

    agregarFaltaHuella (mapa, datos) {
      const clave = datos.id_teacher + '|' + datos.fecha
      if (!mapa[clave]) {
        mapa[clave] = {
          clave,
          id_teacher: Number(datos.id_teacher),
          teacher: datos.teacher,
          fecha: datos.fecha,
          plantel: datos.plantel || '',
          grupos: [],
          horas: 0,
          monto: 0,
          horas_tarifa: {},
        }
      }
      const falta = mapa[clave]
      if (falta.grupos.indexOf(datos.grupo) === -1) falta.grupos.push(datos.grupo)
      falta.horas += datos.horas
      falta.monto += datos.monto
      const tarifa = String(Number(datos.tarifa) || 0)
      falta.horas_tarifa[tarifa] = (falta.horas_tarifa[tarifa] || 0) + datos.horas
    },

    armarFaltasHuellaSab (diasConChecada, hoy) {
      const semana = Number(this.selectedHeaders)
      const mapa = {}

      ;(this.gruposActivos || []).forEach((g) => {
        if (this.esGrupoOnlineHuella(g)) return
        DIAS_BLOQUE.forEach((d) => {
          const slot = d + semana
          const idTeacher = g[slot]
          if (!g[slot + '_n'] || !this.esTeacherHuella(idTeacher)) return

          const fecha = this.normalizarFechaHuella(g[slot + '_fecha'])
          if (!fecha || fecha > hoy || diasConChecada[idTeacher + '|' + fecha]) return

          const tarifa = this.tarifaHuella(idTeacher, 'hora_2')
          this.agregarFaltaHuella(mapa, {
            id_teacher: idTeacher,
            teacher: g[slot + '_n'],
            fecha,
            plantel: g.plantel,
            grupo: g.grupo,
            horas: 1,
            tarifa,
            monto: tarifa,
          })
        })
      })

      return Object.keys(mapa).map((k) => mapa[k])
    },

    armarFaltasHuellaQuin (diasConChecada, hoy) {
      const semana = Number(this.selectedHeaders) - 1 === 0 ? 4 : Number(this.selectedHeaders) - 1
      const bloques = [1, 2].includes(semana) ? [1, 2] : [3, 4]
      const mapa = {}

      ;(this.gruposQuincena || []).forEach((g) => {
        if (this.esGrupoOnlineHuella(g) || g.sabado) return
        bloques.forEach((b) => {
          DIAS_BLOQUE.forEach((d) => {
            const slot = d + b
            const idTeacher = g[slot]
            if (!g[slot + '_n'] || !this.esTeacherHuella(idTeacher)) return
            if (!g.domingo && !g[DIA_SEMANA_BLOQUE[d]]) return

            const fecha = this.normalizarFechaHuella(g[slot + '_fecha'])
            if (!fecha || fecha > hoy || diasConChecada[idTeacher + '|' + fecha]) return

            const horas = g.domingo ? 1 : (Number(g.horas_dia) || 0)
            const tarifa = this.tarifaHuella(idTeacher, g.domingo ? 'hora_3' : 'hora_1')

            this.agregarFaltaHuella(mapa, {
              id_teacher: idTeacher,
              teacher: g[slot + '_n'],
              fecha,
              plantel: g.plantel,
              grupo: g.grupo,
              horas,
              tarifa,
              monto: horas * tarifa,
            })
          })
        })
      })

      return Object.keys(mapa).map((k) => mapa[k])
    },

    async cargarHuellasNomina () {
      this.revisadoHuellaSab = false
      this.revisadoHuellaQuin = false
      this.errorExcepcionesHuella = ''
      this.excepcionesHuella = []
      this.baseComparativaHuellaQ = (this.tabla1ComparativaQ || []).map((fila) => ({
        valor_hora: fila.valor_hora,
        numero_horas: fila.numero_horas,
        costo: fila.costo,
      }))

      const hoy = this.hoyHuella()
      const diasConChecada = this.diasConChecadaHuella()
      const ordenar = (a, b) => a.fecha.localeCompare(b.fecha) || String(a.teacher).localeCompare(String(b.teacher), 'es')

      this.faltasHuellaSab = this.armarFaltasHuellaSab(diasConChecada, hoy).sort(ordenar)
      this.faltasHuellaQuin = this.quincenaHuellaActiva
        ? this.armarFaltasHuellaQuin(diasConChecada, hoy).sort(ordenar)
        : []

      const fechas = this.faltasHuellaSab.concat(this.faltasHuellaQuin).map((f) => f.fecha).sort()
      if (fechas.length) {
        try {
          const response = await this.$http.post('nomina.huellas.excepciones', {
            fecha_inicio: fechas[0],
            fecha_fin: fechas[fechas.length - 1],
          })
          this.excepcionesHuella = response.data || []
        } catch (error) {
          let msg = 'No se pudieron cargar las excepciones de huella'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.errorExcepcionesHuella = msg
        }
      }

      await this.cargarRevisionesHuella()
      this.aplicarDescuentosHuella()
    },

    async cargarRevisionesHuella () {
      if (!this.ciclo) return
      try {
        const response = await this.$http.post('nomina.huellas.revisiones', {
          id_ciclo: this.ciclo.id_ciclo,
          semana: this.selectedHeaders,
        })
        const revisadoCon = (tipo, faltas) => {
          const revision = (response.data || []).find((r) => Number(r.tipo_nomina) === tipo)
          return !!revision && Number(revision.faltas) >= faltas.length
        }
        this.revisadoHuellaSab = revisadoCon(1, this.faltasHuellaSab)
        this.revisadoHuellaQuin = revisadoCon(2, this.faltasHuellaQuin)
      } catch (error) {
        let msg = 'No se pudo consultar la revisión de huellas'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarErrorDirecto(msg)
      }
    },

    montoHuella (valor) {
      const n = parseFloat(String(valor == null ? '' : valor).replace(/[$,]/g, ''))
      return isNaN(n) ? 0 : n
    },

    /** Quita de la comparativa de la quincena actual las horas y el costo de los días sin huella no justificados. */
    ajustarComparativaHuellaQ () {
      const base = this.baseComparativaHuellaQ || []
      if (!this.quincenaHuellaActiva || !base.length) return

      const horasPorCategoria = {}
      let horasDescontar = 0
      let montoDescontar = 0
      this.faltasHuellaQuin.forEach((f) => {
        if (f.excepcion) return
        horasDescontar += f.horas
        montoDescontar += f.monto
        if (f.id_teacher >= 100000) return
        Object.keys(f.horas_tarifa || {}).forEach((tarifa) => {
          horasPorCategoria[tarifa] = (horasPorCategoria[tarifa] || 0) + f.horas_tarifa[tarifa]
        })
      })

      let impartidas = null
      this.tabla1ComparativaQ = base.map((fila) => {
        const nueva = { valor_hora: fila.valor_hora, numero_horas: fila.numero_horas, costo: fila.costo }
        const categoria = String(Number(fila.valor_hora))
        if (fila.valor_hora === 'Horas impartidas') {
          nueva.numero_horas = fila.numero_horas - horasDescontar
          nueva.costo = this.format(this.montoHuella(fila.costo) - montoDescontar)
          impartidas = nueva
        } else if (horasPorCategoria[categoria]) {
          nueva.numero_horas = fila.numero_horas - horasPorCategoria[categoria]
          nueva.costo = this.format(nueva.numero_horas * Number(fila.valor_hora))
        }
        return nueva
      })

      if (impartidas && impartidas.numero_horas > 0) {
        this.costoHora2 = this.format(this.montoHuella(impartidas.costo) / impartidas.numero_horas)
      }
      this.motivoDiferenciasQ()
    },

    aplicarDescuentosHuella () {
      const buscarExcepcion = (f) => this.excepcionesHuella.find((e) => e.id_teacher == f.id_teacher && e.fecha == f.fecha) || null
      const conExcepcion = (lista) => lista.map((f) => Object.assign({}, f, {
        excepcion: buscarExcepcion(f),
        grupos_texto: f.grupos.join(', '),
      }))

      this.faltasHuellaSab = conExcepcion(this.faltasHuellaSab)
      this.faltasHuellaQuin = conExcepcion(this.faltasHuellaQuin)

      const sumarPorTeacher = (lista) => {
        const totales = {}
        lista.forEach((f) => {
          if (f.excepcion) return
          totales[f.id_teacher] = (totales[f.id_teacher] || 0) + f.monto
        })
        return totales
      }

      const descSab = sumarPorTeacher(this.faltasHuellaSab)
      const descQuin = sumarPorTeacher(this.faltasHuellaQuin)

      // La base se guarda no enumerable para que no viaje en la requisición ni en el Excel.
      const guardarBase = (t, campo) => {
        const llave = '__base_' + campo
        if (t[llave] === undefined) {
          Object.defineProperty(t, llave, { value: this.toNumber(t[campo]), enumerable: false, writable: true })
        }
        return t[llave]
      }

      const filas = this.teachers || []
      const esFilaTotal = (t) => Number(t.id_teacher) === 100000 || t.teacher === 'TOTAL'

      filas.forEach((t) => {
        if (esFilaTotal(t)) return
        const sab = descSab[t.id_teacher] || 0
        const quin = descQuin[t.id_teacher] || 0

        if (t.PAGO_SABADO !== undefined) {
          t.PAGO_SABADO = this.format(Math.max(0, guardarBase(t, 'PAGO_SABADO') - sab))
        }
        if (t.PAGO_SABADO_TOTAL !== undefined) {
          t.PAGO_SABADO_TOTAL = this.format(Math.max(0, guardarBase(t, 'PAGO_SABADO_TOTAL') - sab))
        }
        if (this.quincenaHuellaActiva && t.pago_quincena !== undefined) {
          t.pago_quincena = this.format(Math.max(0, guardarBase(t, 'pago_quincena') - quin))
        }
        if (this.quincenaHuellaActiva && t.total_final !== undefined) {
          t.total_final = this.format(this.montoHuella(t.pago_quincena) - this.montoHuella(t.REBAJES) + this.montoHuella(t.PAGO_DOBLES))
        }

        this.$set(t, 'DESC_HUELLA_SAB', this.format(sab))
        this.$set(t, 'DESC_HUELLA_QUIN', this.format(quin))
      })

      const filaTotal = filas.find(esFilaTotal)
      if (filaTotal) {
        const sumar = (campo) => this.format(filas
          .filter((t) => !esFilaTotal(t))
          .reduce((suma, t) => suma + this.montoHuella(t[campo]), 0))
        ;['PAGO_SABADO', 'pago_quincena', 'total_final'].forEach((campo) => {
          if (filaTotal[campo] !== undefined) filaTotal[campo] = sumar(campo)
        })
        this.$set(filaTotal, 'DESC_HUELLA_SAB', sumar('DESC_HUELLA_SAB'))
        this.$set(filaTotal, 'DESC_HUELLA_QUIN', sumar('DESC_HUELLA_QUIN'))
      }

      this.teachers = filas.slice()
      this.ajustarComparativaHuellaQ()
    },

    abrirHuellas (tipo) {
      this.tipoHuellas = tipo
      this.searchHuellas = ''
      this.dialogHuellas = true
    },

    marcarHuellasRevisadas () {
      if (!this.ciclo) return
      const tipo = this.tipoHuellas == 2 ? 2 : 1

      this.cargar = true
      this.$http.post('nomina.huellas.revision.add', {
        id_ciclo: this.ciclo.id_ciclo,
        semana: this.selectedHeaders,
        tipo_nomina: tipo,
        faltas: this.faltasHuellaVista.length,
        id_usuario: this.getdatosUsuarioERPERP.iderp,
      }).then(() => {
        if (tipo == 2) {
          this.revisadoHuellaQuin = true
        } else {
          this.revisadoHuellaSab = true
        }
        this.dialogHuellas = false
        this.validarSuccess('Revisión guardada')
      }).catch((error) => {
        this.validarError(error.response.data.message)
      }).finally(() => { this.cargar = false })
    },

    abrirExcepcionHuella (falta) {
      this.faltaHuellaSeleccionada = falta
      this.motivoExcepcionHuella = ''
      this.dialogExcepcionHuella = true
    },

    guardarExcepcionHuella () {
      const falta = this.faltaHuellaSeleccionada
      const motivo = String(this.motivoExcepcionHuella || '').trim()
      if (!falta) return
      if (!motivo) {
        return this.validarErrorDirecto('Escribe el motivo de la excepción')
      }

      const payload = {
        id_teacher: falta.id_teacher,
        fecha: falta.fecha,
        tipo_nomina: this.tipoHuellas,
        id_ciclo: this.ciclo ? this.ciclo.id_ciclo : null,
        semana: this.selectedHeaders,
        motivo,
        id_usuario: this.getdatosUsuarioERPERP.iderp,
      }

      this.cargar = true
      this.$http.post('nomina.huellas.excepcion.add', payload).then((response) => {
        this.excepcionesHuella.push({
          idnomina_teacher_excepcion_huella: response.data.id,
          id_teacher: falta.id_teacher,
          fecha: falta.fecha,
          tipo_nomina: this.tipoHuellas,
          motivo,
          usuario_autoriza: this.getdatosUsuarioERPERP.nombre_completo || '',
        })
        this.aplicarDescuentosHuella()
        this.dialogExcepcionHuella = false
        this.validarSuccess('Excepción registrada')
      }).catch((error) => {
        this.validarError(error.response.data.message)
      }).finally(() => { this.cargar = false })
    },

    eliminarExcepcionHuella (falta) {
      if (!falta || !falta.excepcion) return
      const id = falta.excepcion.idnomina_teacher_excepcion_huella

      this.cargar = true
      this.$http.post('nomina.huellas.excepcion.delete', {
        id,
        id_usuario: this.getdatosUsuarioERPERP.iderp,
      }).then(() => {
        this.excepcionesHuella = this.excepcionesHuella.filter((e) => e.idnomina_teacher_excepcion_huella != id)
        this.aplicarDescuentosHuella()
        this.validarSuccess('Excepción eliminada')
      }).catch((error) => {
        this.validarError(error.response.data.message)
      }).finally(() => { this.cargar = false })
    },
  },
}
